<div class="multi-language">
  <div>
    <i class="icon icon-language"></i>
  </div>
  <ng-content></ng-content>
</div>
